import { useSuspenseQuery } from '@tanstack/react-query';
import { useDailyRainfallQueryKey } from 'app/agriculture/hooks/useDailyRainfall/useDailyRainfallQueryKey';
import { parseDailyRainfallQueryData } from 'app/agriculture/hooks/useDailyRainfall/parseDailyRainfallQueryData';

export function useDailyRainfall({ deviceId }: { deviceId?: string }) {
    const { generateDailyRainfallQueryKey } = useDailyRainfallQueryKey();
    const queryKey = generateDailyRainfallQueryKey({ deviceId });
    const { data } = useSuspenseQuery({ queryKey });

    return parseDailyRainfallQueryData(data);
}
